import { formatCurrency } from '@apply/ui';
import { sumBudgetNumbers } from '../functions/sumBudgetNumbers';
import { IBudgetConstruction, IBudgetFixFlip, IBudgetLand } from '@apply/api/src/api/ApplyApi';

interface BudgetTotalParameters {
    budget: IBudgetConstruction | IBudgetFixFlip | IBudgetLand;
}

export const BudgetTotal: React.FC<BudgetTotalParameters> = ({ budget }) => {
    if (!budget) return;

    return (
        <div style={{ paddingTop: 40, display: 'flex', alignItems: 'center', gap: '25px' }}>
            <h4>Total:</h4>
            <h5>{formatCurrency(sumBudgetNumbers(budget.values), 0)}</h5>
        </div>
    );
};
